var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsChevronDownSmWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20715 6.48824C5.47587 6.22986 5.90318 6.23824 6.16156 6.50696L9.5 10.0509L12.8384 6.50696C13.0968 6.23824 13.5241 6.22986 13.7928 6.48824C14.0616 6.74663 14.0699 7.17393 13.8116 7.44265L9.98656 11.4927C9.8593 11.625 9.68361 11.6998 9.5 11.6998C9.31639 11.6998 9.1407 11.625 9.01344 11.4927L5.18844 7.44265C4.93005 7.17393 4.93843 6.74663 5.20715 6.48824Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsChevronDownSmWhite);
export default __webpack_public_path__ + "static/media/es_chevron_down_sm_white.f4272123ece97ee690a79d369e29ef1e.svg";
export { ForwardRef as ReactComponent };